import React, { createContext, useContext, useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';
import Avatar from './avatar';
import './OpportunityAnalytics.css';
interface Request {
	id: number;
	status: string;
	dropdown1: string;
	dropdown2: string;
	startDate: string;
	description: string;
	endDate: string;
	userId: string;
}

interface OpportunityAnalyticsContextType {
	startDate: string,
	setStartDate: React.Dispatch<React.SetStateAction<string>>;
	endDate: string,
	setEndDate: React.Dispatch<React.SetStateAction<string>>;
	selectedPage: string;
	requests: Request[];
	setRequests: React.Dispatch<React.SetStateAction<Request[]>>;
	handlePageChange: (page: string) => void;
}
const OpportunityAnalyticsContext = createContext<OpportunityAnalyticsContextType | undefined>(undefined);

export const OpportunityAnalyticsProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
	const [selectedPage, setSelectedPage] = useState<string>('dashboard');
	const [requests, setRequests] = useState<Request[]>([]);
	const [startDate, setStartDate] = useState('');
	const [endDate, setEndDate] = useState('');

	const handlePageChange = (page: string) => {
		setSelectedPage(page);
	};

	return (
		<OpportunityAnalyticsContext.Provider value={{ endDate, setEndDate, startDate, setStartDate, selectedPage, requests, setRequests, handlePageChange }}>
			{children}
		</OpportunityAnalyticsContext.Provider>
	);
};

export const useOpportunityAnalyticsContext = () => {
	const context = useContext(OpportunityAnalyticsContext);
	if (!context) {
		throw new Error('useOpportunityAnalyticsContext must be used within OpportunityAnalyticsProvider');
	}
	return context;
};

const OpportunityAnalytics: React.FC = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const [activeTab, setActiveTab] = useState<string>('opportunity-analytics');

	useEffect(() => {
		const path = location.pathname.split('/').pop();
		setActiveTab(path || 'opportunity-analytics');
	}, [location.pathname]);

	const handleTabClick = (page: string) => {
		setActiveTab(page);
		navigate(page);
	};

	return (
		<OpportunityAnalyticsProvider>
			<div className="opportunity-analytics-container">
				<aside className="sidebar">
					<div className="tabs">
						<div className={`tab ${activeTab === 'opportunity-analytics' ? 'active' : ''}`} onClick={() => handleTabClick('')}>
							Dashboard
						</div>
						<div
							className={`tab ${activeTab === 'analysis-request' ? 'active' : ''}`}
							onClick={() => handleTabClick('analysis-request')}
						>
							Analysis Request
						</div>
						<div
							className={`tab ${activeTab === 'submitted-requests' ? 'active' : ''}`}
							onClick={() => handleTabClick('submitted-requests')}
						>
							Request Tracking
						</div>
						<div
							className={`tab ${activeTab === 'cluster-manager' ? 'active' : ''}`}
							onClick={() => handleTabClick('cluster-manager')}
						>
							Data Mapping
						</div>
						{/* <div className="avatar-container">
							<Avatar />
						</div> */}
					</div>
				</aside>
				<div className="main-content">
					<main className="content-area">
						<Outlet />
					</main>
				</div>
			</div>
		</OpportunityAnalyticsProvider>
	);
};

export default OpportunityAnalytics;
